import { useMemo } from "react";
import { withTranslation } from "react-i18next";
import Spinners from "../../components/Common/Spinner";
import { useUserMe } from "../../api/users";
import { isUserActionRequired } from "../../helpers/userStatusHelper";
import {
  getWorkerDashboardStatus,
  getWorkerDisplayName,
  mapWorkerApiToFormValues,
} from "../update-profile/worker-profile/mapWorkerApiToFormValues";
import WorkerStatusStrip from "./components/WorkerStatusStrip";
import WorkerDashboardHero from "./components/WorkerDashboardHero";
import WorkerIdentityCard from "./components/WorkerIdentityCard";
import WorkerProfileAvailabilityCard from "./components/WorkerProfileAvailabilityCard";
import UpcomingAssignmentsTable from "./components/UpcomingAssignmentsTable";

const WorkerDashboard = ({ t }) => {
  document.title = t("workerDashboardPageTitle", "Dashboard | Worker");

  const userMe = useUserMe();
  const raw = useMemo(
    () => userMe?.data?.data ?? userMe?.data ?? {},
    [userMe.data]
  );
  // const worker = raw.worker ?? {};

  const formValues = useMemo(() => mapWorkerApiToFormValues(raw), [raw]);

  const displayName = useMemo(() => getWorkerDisplayName(raw), [raw]);
  const dashboardStatus = useMemo(
    () => getWorkerDashboardStatus(raw, formValues.profileAvailability?.status),
    [raw, formValues.profileAvailability?.status]
  );
  const actionRequired = isUserActionRequired(raw);
  const actionRequiredReason =
    typeof raw.reason === "string" ? raw.reason.trim() : "";

  const isLoading = userMe.isLoading || userMe.isPending;

  return (
    <div className="page-content">
      <div className="container-fluid">
        {isLoading ? (
          <Spinners setLoading={() => {}} />
        ) : (
          <>
            <WorkerDashboardHero
              displayName={displayName || t("worker", "Worker")}
              isApproved={dashboardStatus.isApproved}
            />
            <WorkerStatusStrip
              isActive={dashboardStatus.isActive}
              isActionRequired={actionRequired}
              reason={actionRequiredReason}
            />

            {/* Worker QR UI hidden — was: qrPng, userSlug, userId */}
            <WorkerIdentityCard
              uploadSelfieUrl={formValues.personalInformation?.uploadSelfieUrl}
              // qrPng={worker.qrPng}
              // userSlug={raw.slug}
              // userId={raw.id}
            />

            <WorkerProfileAvailabilityCard
              formValues={formValues}
              onSaved={() => userMe.refetch()}
            />

            <UpcomingAssignmentsTable />
          </>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(WorkerDashboard);
